import * as React from 'react';
import { Route, Routes } from 'react-router';

import { routes } from 'config/routes';

import {
  FormInitPage,
  FormListPage,
  FormSteps,
  FormReviewPage,
  FormReviewPivotTable,
  FormReviewFlatTable,
} from './pages';
import { FormCreationRoutes } from './specificRoutesGroups';

/**
 * Роуты связанные с формой
 * @constructor
 */
const FormRoutes: React.FC = () => {
  return (
    <Routes>
      <Route index element={<FormListPage />} />
      <Route element={<FormCreationRoutes />}>
        <Route path={routes.form.formSteps.mask} element={<FormSteps />} />
        <Route path={routes.form.initForm.mask} element={<FormInitPage />} />
      </Route>
      <Route path={routes.form.formReview.mask} element={<FormReviewPage />}>
        <Route index element={<FormReviewPivotTable />} />
        <Route
          path={routes.form.formReview.flat.mask}
          element={<FormReviewFlatTable />}
        />
      </Route>
    </Routes>
  );
};

export default FormRoutes;
